module.exports = __webpack_public_path__ + "img/co_branded_banner.693c0bd6.svg";